import { Text } from '../../../../shared-components';
import { Masonry } from '../../../../shared-components/masonry/Masonry';
import { SimpleFieldValue } from './SimpleFieldValue';

export const Conditions = ({ conditions }) => {
  return (
    <Masonry.Group>
      <Masonry.Group.Title value="Listed Conditions" />
      <Masonry.Group.Content>
        {conditions.map(({ Name, Percentage }, idx) => (
          <Masonry.Group.Item key={Name + idx}>
            <Text label>{Name}</Text>
            <SimpleFieldValue field={{ Type: 'percent', value: Percentage }} />
          </Masonry.Group.Item>
        ))}
      </Masonry.Group.Content>
    </Masonry.Group>
  );
};
